import React from 'react';
import './Banner.scss';
import bannerImg from '../../assets/banner/3.jpg';
import doctorImg from '../../assets/banner/doctor.png';
import bannerPattern from '../../assets/banner/pattern_02.png';
import shapeOne from '../../assets/banner/vector_01.png';
import shapeTwo from '../../assets/banner/vector_02.png';
import shapeThree from '../../assets/banner/vector_03.png';
import shapeFour from '../../assets/banner/pattern.png';

const Banner = () => {

    return (
        <section className='section-bg section-common banner-section'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text">
                                    <div className="opening-announcement">
                                        <span className="announcement-badge">✨ Now Open in Yamunanagar! ✨</span>
                                    </div>
                                    <h1>TRUECARE DENTAL & IMPLANT CENTER</h1>
                                    <p className="doctor-info">👩‍⚕️ Dr. Vinamrata (MDS – Govt. Dental College, Ahmedabad)</p>
                                    
                                    <div className="offer-highlight">
                                        <h2>🦷 Free Dental Check-Up</h2>
                                        <h3>💥 + 15% OFF on All Treatments</h3>
                                        <div className="limited-offer">
                                            <span>⏰ Limited Period Offer!</span>
                                        </div>
                                    </div>

                                    <div className="banner-bottom">
                                        <div className="phone-call-btn">
                                            <a href="tel:6395947006" className="call-button">
                                                <div className="call-icon">📞</div>
                                                <div className="call-text">
                                                    <span className="call-label">Call Now</span>
                                                    <span className="phone-number">6395947006</span>
                                                </div>
                                            </a>
                                        </div>

                                        <div className="whatsapp-btn">
                                            <a href="https://wa.me/6395947006" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
                                                <div className="whatsapp-icon">
                                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/768px-WhatsApp.svg.png?20220228223904" alt="WhatsApp" />
                                                </div>
                                                <div className="whatsapp-text">
                                                    <span className="whatsapp-label">WhatsApp</span>
                                                    <span className="whatsapp-number">6395947006</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="banner-img-area">
                                    <div className="banner-img">
                                        <img src={bannerImg} alt="banner model" />
                                    </div>
                                    <div className='info-box'>
                                        <div className="info-img">
                                            <img src={doctorImg} alt="doctor" />
                                        </div>
                                        <div className='info-text'>
                                            <p>Dr. Vinamrata</p>
                                            <p><small>MDS Specialist</small></p>
                                        </div>
                                    </div>  

                                    {/* Vector Shapes */}
                                    <div className="shapes">
                                        <img src={shapeOne} alt="shape" />
                                        <img src={shapeTwo} alt="shape" />
                                        <img src={shapeThree} alt="shape" />
                                        <img src={shapeFour} alt="shape" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner Pattern Vector*/}
            <img className='banner-pattern' src={bannerPattern} alt="banner pattern" />
        </section>
    );
};

export default Banner;